import axios from '@/utils/axios'

export default async function GetCovers({queryKey}: any) {
  const [_, product_id, userCurrency] = queryKey;
  
  const {data} = await axios.get(
    process.env.NEXT_PUBLIC_API_URL +
      '/products/get-product-covers/' +
      product_id,
    {
      params: {
        currency: userCurrency
      }
    }
  )
  return data
}
